
import { BasicButton } from "@goodgamestudios/asset-globals";

import { BasicTutorialController } from "../../../basic/controller/BasicTutorialController";
import { Balancing } from "../../constants/shared/Balancing";
import { Poker2TutorialEvent } from "../../event/Poker2TutorialEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Panel } from "./Poker2Panel";

import { NumberStringHelper } from "../../helper/NumberStringHelper";

import DisplayObject = createjs.DisplayObject;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;
import { TweenMaxGroup } from "../helper/TweenMaxGroup";

import Ticker = createjs.Ticker;

export class Poker2TutorialPanel extends Poker2Panel {
    public static NAME: string = "PokerTutorialPanel";

    private TUT_CHIPS: number = NaN;
    private TUT_GOLD: number = NaN;
    public tableName: string;

    private tutorialSpotlight: Poker2TutorialSpotlight;
    private tutorialInfo: Poker2TutorialInfo;
    private avatarPosition: Poker2TutorialAvatarAnimated;
    private avatarHead: Poker2TutorialAvatarAnimated;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
        this.index = 120;
        this.tutorialSpotlight = new Poker2TutorialSpotlight(this.tutorialPanel.mc_PokerTutorialSpotlight);
        this.tutorialInfo = new Poker2TutorialInfo(this.tutorialPanel.mc_stepinfo);
        this.avatarPosition = new Poker2TutorialAvatarAnimated(this.tutorialPanel.mc_avatarPosition.mc_avatar);

        this.tutorialPanel.mc_avatarPosition.visible = false;
        this.tutorialPanel.mc_avatarPosition.mouseEnabled = false;

        this.tutorialPanel.mc_stepinfo.visible = false;

        this.tutorialPanel.mc_arrow.mouseEnabled = false;
        this.hideTutorialArrow();

        this.TUT_CHIPS = 1000;
        this.TUT_GOLD = 3;
    }

    protected init(): void {

        this.tutorialPanel.gotoAndStop(1);
        this.tutorialPanel.mc_welcome.visible = false;
        this.tutorialPanel.mc_welcomeRepeat.visible = false;

        Ticker.addEventListener("tick", this.onTick);

        Poker2LayoutManager.CANVAS_RESIZED_SIGNAL.add(this.bindFunction(this.onWindowResized));

        super.init();
    }

    private onWindowResized(): void {
        this.updatePosition();
        TutorialHitAreaHelper.updateHitAreaPosition();
    }

    public destroy(): void {
        super.destroy();
        Ticker.removeEventListener("tick", this.onTick);
        Poker2LayoutManager.CANVAS_RESIZED_SIGNAL.remove(this.bindFunction(this.onWindowResized));
    }

    private onTick = (props: createjs.TickerEvent): void => {
        if (!Ticker.paused) {
            Poker2LayoutManager.getInstance().renderTutorialStage(props);
        }
    }

    protected onTutorialEvent(event: Poker2TutorialEvent): void {
        console.log("TUTORIAL STEP: ", Poker2TutorialController.getInstance().tutorialState);

        this.tutorialSpotlight.hasSpotLight = false;
        this.tutorialInfo.show();
        this.tutorialPanel.mc_avatarPosition.visible = true;

        switch (Poker2TutorialController.getInstance().tutorialState) {
            case BasicTutorialController.TUT_STATE_WELCOME:
                this.tutorialPanel.gotoAndStop(1);
                this.tutorialPanel.changeTextFieldCacheScale(Poker2LayoutManager.GAME_SCALE_FACTOR);
                this.tutorialPanel.mc_avatarPosition.visible = false;
                this.tutorialInfo.hide();
                this.hideSpotlight();
                this.hideTutorialArrow();
                //
                if (Poker2Model.userData.tutorialDone) {
                    // b) then user repeat this tutorial
                    this.tutorialPanel.mc_welcome.visible = false;
                    this.tutorialPanel.mc_welcomeRepeat.visible = true;
                    this.avatarHead = new Poker2TutorialAvatarAnimated(this.tutorialPanel.mc_welcomeRepeat.mc_avatar);
                    this.tutorialPanel.mc_welcomeRepeat.btn_goLobby.label = Poker2Model.languageData.getTextById("generic_btn_no");
                    this.tutorialPanel.mc_welcomeRepeat.btn_goTutorial.label = Poker2Model.languageData.getTextById("generic_btn_yes");
                    this.tutorialPanel.mc_welcomeRepeat.txt_title.text = Poker2Model.languageData.getTextById("tut_step1_welcome_title");
                    this.tutorialPanel.mc_welcomeRepeat.txt_copy.text = Poker2Model.languageData.getTextById("tut_step1b_welcome_copy", [Poker2Model.userData.userName]);

                    this.txtCenter(this.tutorialPanel.mc_welcomeRepeat.btn_goLobby);
                    this.txtCenter(this.tutorialPanel.mc_welcomeRepeat.btn_goTutorial);
                }
                else {
                    // a) ist first visit
                    this.tutorialPanel.mc_welcome.visible = true;
                    this.tutorialPanel.mc_welcomeRepeat.visible = false;
                    this.avatarHead = new Poker2TutorialAvatarAnimated(this.tutorialPanel.mc_welcome.mc_avatar);
                    this.tutorialPanel.mc_welcome.btn_goLobby.label = Poker2Model.languageData.getTextById("generic_btn_no");
                    this.tutorialPanel.mc_welcome.btn_goTutorial.label = Poker2Model.languageData.getTextById("generic_btn_yes");
                    this.tutorialPanel.mc_welcome.txt_title.text = Poker2Model.languageData.getTextById("tut_step1_welcome_title");
                    this.tutorialPanel.mc_welcome.txt_copy.text = Poker2Model.languageData.getTextById("tut_step1a_welcome_copy", [Poker2Model.userData.userName]);
                    this.tutorialPanel.mc_welcome.txt_chips.text = NumberStringHelper.groupString(this.TUT_CHIPS, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                    this.tutorialPanel.mc_welcome.txt_gold.text = NumberStringHelper.groupString(this.TUT_GOLD, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

                    this.txtCenter(this.tutorialPanel.mc_welcome.btn_goLobby);
                    this.txtCenter(this.tutorialPanel.mc_welcome.btn_goTutorial);
                }
                break;
            case "tut_step2_tableSelection":
                this.tutorialPanel.gotoAndStop(2);
                this.tutorialInfo.setWXYE(300, 400, 380, false);
                break;
            case "tut_step3_playButton":
                this.tutorialPanel.gotoAndStop(3);
                this.tutorialInfo.setWXYE(300, 360, 370, false);
                break;
            case "tut_step4_freeSeat":
                this.tutorialPanel.gotoAndStop(4);
                this.tutorialInfo.setWXYE(300, 340, 300, false);
                break;
            case "tut_step5_buyIn":
                this.tutorialPanel.gotoAndStop(5);
                this.tutorialInfo.setWXYE(180, 650, 300, false);
                break;
            case "tut_step6_dealerButton":
                this.tutorialPanel.gotoAndStop(6);
                this.tutorialInfo.setWXYE(180, 650, 300);
                break;
            case "tut_step7_smallBlind":
                this.tutorialPanel.gotoAndStop(7);
                this.tutorialInfo.setWXYE(180, 650, 300);
                break;
            case "tut_step8_bigBlind":
                this.tutorialPanel.gotoAndStop(8);
                this.tutorialInfo.setWXYE(180, 650, 300);
                break;
            case "tut_step9_holeCards":
                this.tutorialPanel.gotoAndStop(9);
                this.tutorialInfo.setWXYE(180, 650, 300);
                break;
            case "tut_step10_alinaFold":
                this.tutorialPanel.gotoAndStop(10);
                this.tutorialInfo.setWXYE(180, 650, 300);
                break;
            case "tut_step11_actionHelp":
                this.tutorialPanel.gotoAndStop(11);
                this.tutorialInfo.setWXYE(180, 300, 360, false);
                break;
            case "tut_step12_actionHelp2":
                this.tutorialPanel.gotoAndStop(12);
                this.tutorialInfo.setWXYE(180, 300, 340);
                break;
            case "tut_step13_playerActionCall":
                this.tutorialPanel.gotoAndStop(13);
                this.tutorialInfo.setWXYE(180, 300, 360, false);
                break;
            case "tut_step14_timoCall":
                this.tutorialPanel.gotoAndStop(14);
                this.tutorialInfo.setWXYE(180, 550, 300);
                break;
            case "tut_step15_oliverCheck":
                this.tutorialPanel.gotoAndStop(15);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step16_pot":
                this.tutorialPanel.gotoAndStop(16);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step17_flop":
                this.tutorialPanel.gotoAndStop(17);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step18_timoCheck":
                this.tutorialPanel.gotoAndStop(18);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step19_oliverCheck":
                this.tutorialPanel.gotoAndStop(19);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step20_handStrength":
                this.tutorialPanel.gotoAndStop(20);
                this.tutorialInfo.setWXYE(180, 550, 300, false);
                break;
            case "tut_step21_handStrength2":
                this.tutorialPanel.gotoAndStop(21);
                this.tutorialInfo.setWXYE(180, 550, 300);
                break;
            case "tut_step22_playerActionCheck":
                this.tutorialPanel.gotoAndStop(22);
                this.tutorialInfo.setWXYE(180, 550, 200, false);
                break;
            case "tut_step23_turn":
                this.tutorialPanel.gotoAndStop(23);
                this.tutorialInfo.setWXYE(180, 550, 180);
                break;
            case "tut_step24_timoRaise":
                this.tutorialPanel.gotoAndStop(24);
                this.tutorialInfo.setWXYE(180, 550, 200);
                break;
            case "tut_step25_oliverFold":
                this.tutorialPanel.gotoAndStop(25);
                this.tutorialInfo.setWXYE(180, 550, 200);
                break;
            case "tut_step26_playerActionCall":
                this.tutorialPanel.gotoAndStop(26);
                this.tutorialInfo.setWXYE(180, 550, 200, false);
                break;
            case "tut_step27_river":
                this.tutorialPanel.gotoAndStop(27);
                this.tutorialInfo.setWXYE(180, 550, 180);
                break;
            case "tut_step28_timoCheck":
                this.tutorialPanel.gotoAndStop(28);
                this.tutorialInfo.setWXYE(180, 550, 200);
                break;
            case "tut_step29_playerActionRaise":
                this.tutorialPanel.gotoAndStop(29);
                this.tutorialInfo.setWXYE(180, 550, 200, false);
                break;
            case "tut_step30_timoReraise":
                this.tutorialPanel.gotoAndStop(30);
                this.tutorialInfo.setWXYE(180, 550, 200);
                break;
            case "tut_step31_playerActionAllin":
                this.tutorialPanel.gotoAndStop(31);
                this.tutorialInfo.setWXYE(180, 550, 200, false);
                break;
            case "tut_step32_timoAllin":
                this.tutorialPanel.gotoAndStop(32);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step33_showCards":
                this.tutorialPanel.gotoAndStop(33);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step34_victory":
                this.tutorialPanel.gotoAndStop(34);
                this.tutorialInfo.setWXYE(180, 550, 360);
                break;
            case "tut_step35_xpBar":
                this.layoutManager.hideAllDialogs();
                this.tutorialPanel.gotoAndStop(35);
                this.tutorialInfo.setWXYE(220, 550, 340);
                break;
            case "tut_step36_levelUp":
                this.tutorialPanel.gotoAndStop(36);
                this.tutorialInfo.setWXYE(180, 680, 130);
                break;
            case "tut_step37_standUp":
                this.layoutManager.hideAllDialogs();
                this.tutorialPanel.gotoAndStop(37);
                this.tutorialInfo.setWXYE(180, 650, 350, false);
                break;
            case "tut_step38_leaveTable":
                this.tutorialPanel.gotoAndStop(38);
                this.tutorialInfo.setWXYE(180, 650, 350, false);
                break;
            case "tut_step39_congratulation_copy":
                this.tutorialPanel.gotoAndStop(39);
                this.tutorialPanel.changeTextFieldCacheScale(Poker2LayoutManager.GAME_SCALE_FACTOR);
                this.tutorialPanel.mc_avatarPosition.visible = false;
                this.avatarHead = new Poker2TutorialAvatarAnimated(this.tutorialPanel.mc_congratulate.mc_avatar);
                this.tutorialInfo.hide();
                this.hideTutorialArrow();
                this.tutorialPanel.mc_congratulate.changeTextFieldCacheScale(2);
                this.tutorialPanel.mc_congratulate.txt_title.text = Poker2Model.languageData.getTextById("tut_step39_congratulation_title");
                this.tutorialPanel.mc_congratulate.txt_copy.text = Poker2Model.languageData.getTextById("tut_step38_leaveTable");

                this.tutorialPanel.mc_congratulate.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
                // text is truncated in russian
                this.tutorialPanel.mc_congratulate.btn_ok.txt_label.width += 50;
                this.tutorialPanel.mc_congratulate.btn_ok.txt_label.x -= 25;

                if (Poker2Model.userData.tutorialDone) {
                    this.tutorialPanel.mc_congratulate.btn_ok.visible = true;
                    this.tutorialPanel.mc_congratulate.btn_prev.visible = false;
                    this.tutorialPanel.mc_congratulate.btn_next.visible = false;
                }
                else {
                    this.tutorialPanel.mc_congratulate.btn_ok.visible = false;
                    this.tutorialPanel.mc_congratulate.btn_prev.enableButton = false;
                    this.tutorialPanel.mc_congratulate.btn_next.visible = true;
                }
                break;
            case "tut_step40_reward":
                this.tutorialPanel.gotoAndStop(40);
                this.tutorialPanel.changeTextFieldCacheScale(Poker2LayoutManager.GAME_SCALE_FACTOR);
                this.tutorialPanel.mc_avatarPosition.visible = false;
                this.avatarHead = new Poker2TutorialAvatarAnimated(this.tutorialPanel.mc_reward.mc_avatar);
                this.tutorialInfo.hide();
                this.hideTutorialArrow();
                this.tutorialPanel.mc_reward.txt_title.text = Poker2Model.languageData.getTextById("dialog_tutreward_title");
                this.tutorialPanel.mc_reward.txt_copy.text = Poker2Model.languageData.getTextById("tut_step40_reward");
                this.tutorialPanel.mc_reward.txt_chips.text = NumberStringHelper.groupString(this.TUT_CHIPS, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                this.tutorialPanel.mc_reward.txt_gold.text = NumberStringHelper.groupString(this.TUT_GOLD, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

                this.tutorialPanel.mc_reward.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
                // text is truncated in russian
                this.tutorialPanel.mc_reward.btn_ok.txt_label.width += 50;
                this.tutorialPanel.mc_reward.btn_ok.txt_label.x -= 25;
                break;
        }

        if (this.tutorialPanel.mc_avatarPosition.visible) this.avatarPosition.animated();
        if (this.avatarHead) this.avatarHead.animated();
    }

    /**
     * Tutorialstep zurück, dabei werden die automatischen Schritte übersprungen.
     * Werte und Anzeigen müssen zurück gesetzt werden.
     */
    private prevTutStep(): void {
        this.tutorialController.removeArrow();
        console.log("PrevStep " + this.tutorialController.tutorialState);
        switch (this.tutorialController.tutorialState) {
            case "tut_step3_playButton":
                this.layoutManager.state = 11;
                break;
        }
    }

    /**
     * center text for left-/ right button
     */
    private txtCenter(btn: BasicButton): void {
        var rect: Rectangle = btn.getRect(null);
        btn.txt_label.x = rect.left + (btn.width - btn.txt_label.textWidth) / 2;
    }

    protected onClick(event: MouseEvent): void {
        if (instanceOfClass(event.target, "TextField"))
            return;

        if (!event.target.enabled)
            return;

        super.onClick(event);
        switch (this.tutController.tutorialState) {
            case BasicTutorialController.TUT_STATE_WELCOME:
                switch (event.target) {
                    case this.tutorialPanel.mc_welcomeRepeat.btn_goLobby:
                    case this.tutorialPanel.mc_welcome.btn_goLobby:
                        this.tutorialCancel(false);
                        break;
                    case this.tutorialPanel.mc_welcomeRepeat.btn_goTutorial:
                    case this.tutorialPanel.mc_welcome.btn_goTutorial:
                        this.tutController.nextStep();
                        break;
                }
                break;

            case "tut_step39_congratulation_copy":
                switch (event.target) {
                    case this.tutorialPanel.mc_congratulate.btn_ok:
                        this.tutorialCancel(false);
                        break;
                    case this.tutorialPanel.mc_congratulate.btn_prev:
                        this.tutController.prevStep();
                        break;
                    case this.tutorialPanel.mc_congratulate.btn_next:
                        this.tutController.nextStep();
                        break;
                }
                break;

            case "tut_step40_reward":
                this.tutorialController.nextStep();
                this.tutorialController.endTutorial();
                break;

            default:
                if (instanceOfClass(event.target, "Btn_MenuArrowRight") || instanceOfClass(event.target, "Btn_BasicOrange"))
                    this.tutController.nextStep();
                else if (instanceOfClass(event.target, "Btn_MenuArrowLeft")) {
                    this.tutController.prevStep();
                    this.prevTutStep();
                }
                else if (instanceOfClass(event.target, "Btn_Close")) {
                    this.tutorialCancel(true);
                }
                break;
        }
    }

    private tutorialCancel(isShowNoCancelDialog: boolean): void {
        // tut_cancel_copy_rewardAlreadyReceived
        if (isShowNoCancelDialog) {
            this.hide();
            this.hideSpotlight();
            this.layoutManager.showDialog("Poker2TutorialNoCancelDialog");
        }
        else {
            this.tutController.cancelTutorial();
            if (this.layoutManager.currentState != 11) {
                this.layoutManager.state = 11;
            }
        }
    }

    //
    // spotlight
    //

    public hideSpotlight(): void {
        this.tutorialSpotlight.hide();
    }

    /**
     * Show a spotlight, which was already been setup via showSpotlight(rect)
     */
    public showEnabledSpotlight(): void {
        if (this.tutorialSpotlight.hasSpotLight) {
            this.tutorialSpotlight.show();
        }
    }

    /**
     * @rect	is Rectangle, then it is global
     * 			is Sprite, Movieclip, then with getRect to global
     */
    public showSpotlight(rect: any): void {
        if (instanceOfClass(rect, "Rectangle")) {
            this.tutorialSpotlight.onTutStateChange(rect as Rectangle, false);
        }
        else {
            if(rect) {
                this.tutorialSpotlight.onTutStateChange(rect.getRect(this.disp.stage), true);
            }
        }
    }

    //
    // arrow on top
    //

    /**
     * no need for tutorialStepinfo.btn_next.enableButton is true
     */
    public hideTutorialArrow(): void {
        this.tutorialPanel.mc_arrow.visible = false;
    }

    /**
     * sets the arrow above all other objects
     * @param s		sprite, textfiels, ..
     */
    public showTutorialArrow(s: any = null, mirror: boolean = true, flip: boolean = false): void {
        var tween: TweenMaxGroup;
        var rect: Rectangle;
        var alpha: number = NaN;
        //
        this.tutorialPanel.mc_arrow.visible = true;
        this.tutorialPanel.mc_arrow.mouseEnabled = false;
        if (s) {
            rect = s.getRect(this.tutorialPanel);
            alpha = 1;
        }
        else {
            // no like 'arrow allways show' then:
            // tutorialPanel.mc_arrow.visible = false;
            // return;
            rect = this.tutorialPanel.mc_stepinfo.btn_next.getRect(this.tutorialPanel);
            alpha = 1; // or no like, set alpha to 0
        }

        this.tutorialPanel.mc_arrow.scaleX = mirror ? -Math.abs(this.tutorialPanel.mc_arrow.scaleX) : Math.abs(this.tutorialPanel.mc_arrow.scaleX);
        this.tutorialPanel.mc_arrow.scaleY = flip ? -Math.abs(this.tutorialPanel.mc_arrow.scaleY) : Math.abs(this.tutorialPanel.mc_arrow.scaleY);

        var zielX: number = (rect.left + rect.right) / 2;
        var zielY: number = (rect.top + rect.bottom) / 2;
        if (rect.height < rect.width) {
            // small height: arrow to top or buttom
            zielY = flip ? rect.bottom : rect.top;
        }
        else {
            // small width: arrow to left or right
            zielX = mirror ? rect.right : rect.left;
        }

        if (this.tutorialPanel.mc_arrow.visible) {
            tween = new TweenMaxGroup();
            tween.to(this.tutorialPanel.mc_arrow, 1.0, { x: zielX, y: zielY, alpha: alpha, onComplete: this.bindFunction(this.disposeTweenGroup), onCompleteParams: [tween] });
            tween.play();
        }
        else {
            this.tutorialPanel.mc_arrow.x = zielX;
            this.tutorialPanel.mc_arrow.y = zielY;
        }

        // tutorialController.addTutorialArrowAndFlip(tutorialPanel.mc_arrow,mirror,flip);
    }

    private disposeTweenGroup(tween: TweenMaxGroup): void {
        this.tutorialPanel.mc_arrow.play();
        tween.destroy();
        tween = null;
    }

    //
    // getter & setter
    //

    private get tutController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    public get tutorialPanel(): Library.PokerTutorial.TutorialPanel {
        return this.disp as Library.PokerTutorial.TutorialPanel;
    }
}
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2TutorialAvatarAnimated } from "../components/Poker2TutorialAvatarAnimated";
import { Poker2TutorialNoCancelDialog } from "../dialogs/Poker2TutorialNoCancelDialog";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
import { Poker2TutorialInfo } from "./tutorial/Poker2TutorialInfo";
import { Poker2TutorialSpotlight } from "./tutorial/Poker2TutorialSpotlight";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {TutorialHitAreaHelper} from "./tutorial/TutorialHitAreaHelper";
